/**
 * Product Card Mobile Swiper Carousel
 * Initialize Swiper with dots pagination and tap to navigate
 */
(function() {
  function initProductCardSwipers() {
    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded yet');
      return;
    }

    // Only initialize on mobile
    if (window.innerWidth > 999) return;

    const swiperContainers = document.querySelectorAll('.product-card-swiper');

    if (swiperContainers.length === 0) {
      return;
    }

    swiperContainers.forEach(function(swiperEl) {
      // Check if Swiper is already initialized
      if (swiperEl.swiper) {
        return;
      }

      const swiperContainer = swiperEl.closest('.product-card__mobile-swiper');
      const productUrl = swiperContainer ? swiperContainer.getAttribute('data-product-url') : null;
      const paginationEl = swiperEl.querySelector('.swiper-pagination');

      if (!paginationEl) {
        console.warn('Pagination element not found for swiper');
        return;
      }

      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartTime = 0;
      let hasMoved = false;

      // Track touch to distinguish tap from swipe
      swiperEl.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
        hasMoved = false;
      }, { passive: true });

      swiperEl.addEventListener('touchmove', function(e) {
        const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
        if (deltaX > 5 || deltaY > 5) {
          hasMoved = true;
        }
      }, { passive: true });

      try {
        // Initialize Swiper
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 4,
          pagination: {
            el: paginationEl,
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          touchEventsTarget: 'container',
          allowTouchMove: true,
          resistance: true,
          resistanceRatio: 0.85,
          on: {
            click: function(swiper, event) {
              // Only navigate on click if it wasn't a swipe
              const touchDuration = Date.now() - touchStartTime;
              if (!hasMoved && touchDuration < 300 && productUrl) {
                // Use instant navigation if available
                if (window.theme && window.theme.routes && window.theme.routes.instantPage) {
                  window.theme.routes.instantPage.preload(productUrl);
                }
                window.location.href = productUrl;
              }
            }
          }
        });

        // Store swiper instance
        swiperEl.swiper = swiper;
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    });
  }

  // Wait for Swiper to be loaded and DOM ready
  function waitForSwiper(maxAttempts) {
    maxAttempts = maxAttempts || 50; // Max 5 seconds (50 * 100ms)
    let attempts = 0;

    function check() {
      attempts++;

      // Check if Swiper is loaded (either from window.swiperLoaded flag or Swiper global)
      if (typeof Swiper !== 'undefined' || window.swiperLoaded) {
        // Double check Swiper is actually available
        if (typeof Swiper !== 'undefined') {
          // Swiper is loaded, wait for DOM and initialize
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
              setTimeout(initProductCardSwipers, 50);
            });
          } else {
            setTimeout(initProductCardSwipers, 50);
          }
        } else if (attempts < maxAttempts) {
          // Swiper file loaded but Swiper not yet available, wait a bit more
          setTimeout(check, 100);
        } else {
          console.error('Swiper file loaded but Swiper constructor not available');
        }
      } else if (attempts < maxAttempts) {
        // Check again after a short delay
        setTimeout(check, 100);
      } else {
        console.error('Swiper library failed to load after', maxAttempts * 100, 'ms');
      }
    }

    check();
  }

  // Start waiting for Swiper
  // If Swiper is already loaded, initialize immediately
  if (typeof Swiper !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initProductCardSwipers, 50);
      });
    } else {
      setTimeout(initProductCardSwipers, 50);
    }
  } else {
    // Otherwise wait for it to load
    waitForSwiper();
  }

  // Re-initialize when new product cards are loaded (for infinite scroll, etc.)
  const observer = new MutationObserver(function(mutations) {
    if (typeof Swiper !== 'undefined') {
      initProductCardSwipers();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
